import httpManager from "@/app/shared/utils/httpManager";
import {
  ReportTypes,
  CustomerSupportReportTypes,
  CustomerSupportReportTypesNames,
} from "@/app/reports/utils/enums";

export async function fetchResumeType({ filters } = {}) {
  let query = "";
  if (filters.entity) query += `entity=${filters.entity}&`;
  query += `portfolio=${filters.portfolio}&`;
  if (filters.base) query += `base=${filters.base}&`;
  query += `start_date=${filters.date}`;

  const type = CustomerSupportReportTypesNames[CustomerSupportReportTypes.Resume];

  const url = `/reports/${ReportTypes.CustomerSupport}/?type=${type}&${query}`;

  const response = await httpManager.get(url);
  return response?.data;
}
